module.exports = __webpack_public_path__ + "media/images/h-bottle-d33dc997bbe07304ae8e2d93f5686f63.svg";